import _JSXStyle from "styled-jsx/style";
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
const tableCellStyles = ["td.jsx-2229340108{border-bottom:1px solid #e8edf2;font-size:14px;line-height:18px;padding:13px 12px;height:45px;}", "td.jsx-2229340108:dir(rtl){text-align:right;}", ".dense.jsx-2229340108{padding:9px 12px;height:36px;}"];
tableCellStyles.__hash = "2229340108";
export const TableCell = _ref => {
  let {
    role,
    className,
    children,
    colSpan,
    rowSpan,
    dense,
    dataTest
  } = _ref;
  return /*#__PURE__*/React.createElement("td", {
    colSpan: colSpan,
    rowSpan: rowSpan,
    "data-test": dataTest,
    role: role,
    className: "jsx-".concat(tableCellStyles.__hash) + " " + (cx({
      dense
    }, className) || "")
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: tableCellStyles.__hash
  }, tableCellStyles));
};
TableCell.defaultProps = {
  dataTest: 'dhis2-uicore-tablecell'
};
TableCell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  colSpan: PropTypes.string,
  dataTest: PropTypes.string,

  /** Usees less padding and height for information-dense layouts */
  dense: PropTypes.bool,
  role: PropTypes.string,
  rowSpan: PropTypes.string
};